export default {
  namespaced: true,
  state: () => ({
    summaries: {},
    options: {
      executive_summary: {
        fleet_size: {
          icon: "ph-duotone ph-car-profile fs-2 text-dark",
          details: [
            function (all) {
              const v1_percent = Math.ceil((all.v1 / all.total) * 100);
              return `<b style="color: black">${all.v1}</b> Version 1 (${v1_percent}%)`;
            },
            function (all) {
              const v2_percent = Math.ceil((all.v2 / all.total) * 100);
              return `<b style="color: black">${all.v2}</b> Version 2 (${v2_percent}%)`;
            },
          ],
        },
        available_stock: {
          icon: "ph-duotone ph-car fs-2 text-dark",
          details: [],
        },
        asset_value: {
          icon: "ph-duotone ph-notepad fs-2 text-dark",
          smallfont: true,
          details: [
            // eslint-disable-next-line no-unused-vars
            function (all) {
              //   console.log(all);
              return `Includes <b style="color:black;">1</b> asset/s in active incidents.`;
            },
            function (all) {
              return `<b style="color:black;">${all.v1}</b> Version 1`;
            },
            function (all) {
              return `<b style="color:black;">${all.v2}</b> Version 2`;
            },
            // eslint-disable-next-line no-unused-vars
            function (all) {
              return `For Mar 2026`;
            },
          ],
        },
        monthly_income: {
          icon: "ph-duotone ph-tip-jar fs-2 text-dark",
          smallfont: true,
          details: [
            // eslint-disable-next-line no-unused-vars
            function (all) {
              const v = parseFloat(all.v1.replace(/[^0-9.-]+/g, ""));
              const total = parseFloat(all.total.replace(/[^0-9.-]+/g, ""));
              const percent = ((v / total) * 100).toFixed(2);
              return `<b class="fw-bold" style="color:black;">${all.v1}</b> Version 1 (${percent}%)`;
            },
            function (all) {
              const v = parseFloat(all.v2.replace(/[^0-9.-]+/g, ""));
              const total = parseFloat(all.total.replace(/[^0-9.-]+/g, ""));
              const percent = ((v / total) * 100).toFixed(2);
              return `<b class="fw-bold" style="color:black;">${all.v2}</b> Version 2 (${percent}%)`;
            },
            "For Mar 2026",
          ],
        },
        active_subscriptions: {
          icon: "ph-duotone ph-user-check fs-2 text-dark",
          details: [
            // eslint-disable-next-line no-unused-vars
            function (all) {
              console.log(all);
              const percent = Math.floor((all.v1 / all.total) * 100);
              return `<b style="color:black;">${all.v1}</b> Version 1 (${percent}%)`;
            },
            function (all) {
              const percent = Math.floor((all.v2 / all.total) * 100);
              return `<b style="color:black;">${all.v2}</b> Version 1 (${percent}%)`;
            },
          ],
        },
        break_even_units: {
          icon: "ph-duotone ph-warehouse fs-2 text-dark",
          smallfont: true,
          details: [
            `Need <b style="color:black;">87</b> more units to break even`,
            `As of 11 Mar 2026`,
          ],
        },
      },
      debtors_summary: {},
    },
  }),
  mutations: {
    SET_DASHBOARD_SUMMARIES(state, summaries) {
      state.summaries = summaries;
    },
  },
  actions: {
    async getSummaries({ commit }) {
      const response = await fetch("http://localhost:90/dashboard", {
        headers: {
          "Content-Type": "application/x-www-urlform-encoded",
          backend: this.state.login.user.session ?? null,
        },
      });

      const text_response = await response.text();
      const json_response = JSON.parse(text_response);

      commit("SET_DASHBOARD_SUMMARIES", json_response.data);
    },
  },
  getters: {
    summaries(state) {
      let summaries = Object.entries(state.summaries).map(
        ([summary_title, cards]) => {
          cards = Object.entries(cards || {}).map(([card_title, info]) => {
            let details =
              state.options?.[summary_title]?.[card_title]?.details || [];

            state.summaries[summary_title][card_title].details = details.map(
              (d) =>
                typeof d === "function"
                  ? d(state.summaries[summary_title][card_title].count)
                  : d
            );

            info = {
              ...info,
              info: state.options?.[summary_title]?.[card_title] || {
                icon: "",
                details: [],
                smallfont: false,
              },
            };
            return [card_title, info];
          });
          cards = Object.fromEntries(cards);
          return [summary_title, cards];
        }
      );
      summaries = Object.fromEntries(summaries);

      return summaries;
    },
  },
};
